import React from 'react';

const PaymentSuccessIcon = () => {
  return (
    <svg width="102" height="102" viewBox="0 0 102 102" fill="none">
      <path
        d="M51 4C25.043 4 4 25.043 4 51C4 76.957 25.043 98 51 98C76.957 98 98 76.957 98 51C98 25.043 76.957 4 51 4Z"
        stroke="#EE622B"
        strokeWidth="7.9129"
      />
      <path
        d="M28.9102 49.5173L43.7468 65.3431C43.7468 65.3431 68.9547 40.7023 72.6421 37.0967"
        stroke="#EE622B"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PaymentSuccessIcon;
